module.exports = __webpack_public_path__ + "img/debtPayingAbility2.b48b6cc7.png";